import { onNewFolderTextInvalidated } from '../actions/internalActions';
import { getStore } from '../store/store';
import { mutator } from 'satcheljs';

/**
 * Subscribes to onNewFolderTextInvalidated action and mutates newFolderViewState property of moveToStore mutator
 * Invalid name could be due to same folder name existence or string is invalid
 */
mutator(onNewFolderTextInvalidated, () => {
    getStore().newFolderViewState.isInvalid = true;
});
